import {makeObservable} from 'mobx';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'SubtenantArticlesAccessModel';

export class SubtenantArticlesAccessModel extends BaseModel {
  hasAccess: boolean;
  hasPremiumAccess: boolean;

  constructor(props: SubtenantArticlesAccessModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<
        SubtenantArticlesAccessModel,
        SubtenantArticlesAccessModel.Props
      >(props),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace SubtenantArticlesAccessModel {
  export type Props = BaseModel.ModelToProps<SubtenantArticlesAccessModel>;
}
